import { createFileRoute } from "@tanstack/react-router";

import { AreaPage } from "@/components/site/AreaPage";
import { JsonLd } from "@/components/site/JsonLd";
import { AREAS, areaJsonLd } from "@/content/areas";
import { PAGE_META } from "@/content/page-meta";
import { absoluteUrl, seoLinks, ogImage } from "@/lib/seo";

const PATH = "/en/school-estepona";
const meta = PAGE_META["area:estepona:en"];

export const Route = createFileRoute("/en/school-estepona")({
  head: () => ({
    meta: [
      { title: meta.title },
      { name: "description", content: meta.description },
      { property: "og:title", content: meta.title },
      { property: "og:description", content: meta.description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl(PATH) },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "en_GB" },
      ...ogImage(),
    ],
    links: seoLinks(PATH),
  }),
  component: EsteponaEnRoute,
});

function EsteponaEnRoute() {
  const content = AREAS.estepona.en;
  return (
    <>
      <JsonLd scripts={areaJsonLd(content, absoluteUrl(PATH), "en")} />
      <AreaPage locale="en" content={content} currentSvPath="/skola-estepona" />
    </>
  );
}
